import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {AddAdAccountForm, MODE_EDIT} from "./AddAdAccountForm";
import {SheetLogo} from "../../logos/SheetLogo";
import {Spinner} from "../../Spinner";
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";


class EditSheetAdAccountModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            errorLoading: null,
            config: null,
            diagnostic: null,
            currentCsvHeaders: null,
            // Unas filas del archivo TAL COMO ESTÁ HOY. Sin esto, re-mapear es elegir de una
            // lista de nombres a ciegas; con esto el usuario ve el dato y confirma.
            sampleRows: null,
            // El mapeo guardado, ya resuelto contra el archivo de hoy por el backend. Ver el
            // comentario de `initialMapping` en AddAdAccountForm: es lo que evita que la
            // pantalla marque como rotas las columnas que el sync lee perfecto.
            resolvedColumnMapping: null
        };

        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.isOpen) this.fetchDiagnostic();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) this.fetchDiagnostic();
    }

    fetchDiagnostic() {
        this.setState({loading: true, errorLoading: null});
        new APIClient(API_URL + `agency/sheet-ad-account/${this.props.adAccountPk}/`).call('GET').then((response) => {
            if (response.status === 'OK') {
                this.setState({
                    loading: false,
                    config: response.data.config,
                    diagnostic: response.data.diagnostic,
                    currentCsvHeaders: response.data.current_csv_headers,
                    // Un backend sin deployar no manda la clave: `[]` deja la pantalla
                    // exactamente como estaba, sin preview y sin romper nada.
                    sampleRows: response.data.sample_rows || [],
                    resolvedColumnMapping: response.data.resolved_column_mapping || null
                });
            } else {
                this.setState({loading: false, errorLoading: response.error_message || response.status});
            }
        });
    }

    afterSuccessfulSubmit(updatedSheetAdAccountData) {
        this.props.onToggle();
        if (this.props.onSaved) this.props.onSaved(updatedSheetAdAccountData);
    }

    renderBody() {
        const {t} = this.props;

        if (this.state.loading) {
            return (
                <ModalBody>
                    <div style={{textAlign: 'center', padding: '2em'}}>
                        <Spinner color="positive"/>
                        <p style={{marginTop: '1em'}}>{t('sheet_account.diagnostic.loading')}</p>
                    </div>
                </ModalBody>
            );
        }

        if (this.state.errorLoading) {
            return (
                <ModalBody>
                    <p>{t('sheet_account.diagnostic.load_error')}</p>
                </ModalBody>
            );
        }

        return (
            <AddAdAccountForm mode={MODE_EDIT}
                              adAccountPk={this.props.adAccountPk}
                              initialSheetAccount={this.state.config}
                              diagnostic={this.state.diagnostic}
                              currentCsvHeaders={this.state.currentCsvHeaders}
                              sampleRows={this.state.sampleRows}
                              resolvedColumnMapping={this.state.resolvedColumnMapping}
                              afterSuccessfulSubmit={this.afterSuccessfulSubmit}/>
        );
    }

    render() {
        const {t} = this.props;
        return (
            <Modal isOpen={this.props.isOpen}
                   toggle={this.props.onToggle}
                   className={"sheet-import-modal " + (this.props.className || "")}
                   backdrop="static">
                <ModalHeader toggle={this.props.onToggle}>
                    <SheetLogo/>&nbsp;{t('sheet_account.edit_modal_title')}
                </ModalHeader>
                {this.renderBody()}
            </Modal>
        );
    }
}

export const EditSheetAdAccountModal = withTranslation()(EditSheetAdAccountModalComponent);
